import { Slice } from "gatsby"
import { useLayoutEffect } from "react"

import { Box } from "@mui/material"

import { ScrollTrigger } from "@ggs/ui/local/gsap"
import { ChatIconCTA, type FCWC, type TripData } from "."

type LayoutProps = {
  hero?: React.ReactNode
  showChatButton?: boolean
  trip?: TripData
  showContactInfo?: boolean
  hideOnScroll?: boolean
}

const Layout: FCWC<LayoutProps> = ({
  hero,
  showChatButton = true,
  trip = null,
  showContactInfo = true,
  children,
  hideOnScroll = false,
}) => {
  useLayoutEffect(() => {
    ScrollTrigger.refresh()
  }, [])

  return (
    <>
      {/* Because of sticky content, we need to wrap the header / hero separately from the main content */}
      <Slice
        alias="header"
        trip={trip}
        showContactInfo={showContactInfo}
        hideOnScroll={hideOnScroll}
      />
      <>{hero}</>
      <MainContent>{children}</MainContent>
      <Slice alias="Footer" trip={trip} showContactInfo={showContactInfo} />
      {/* <InitialPageLoad /> */}
      {showChatButton && <ChatIconCTA />}
    </>
  )
}

export default Layout

export const MainContent: FCWC = ({ children }) => {
  return (
    <Box
      component="main"
      sx={(theme) => ({
        bgcolor: theme.palette["neutral.100"].main,
        position: "relative",
      })}
    >
      {children}
    </Box>
  )
}
